import { Content } from '../../types';

export const koLantaContent: Content = {
  title: 'קו לנטה - גן עדן שקט ואותנטי בים אנדמן',
  imageUrl: '/images/thailand/ko-lanta/ko-lanta-wide.jpeg',
  introduction:
    'קו לנטה הינו אי קסום ולא מתוייר יתר על המידה, השוכן בים אנדמן ומשתייך למחוז קראבי שבתאילנד. האי מורכב משני איים מרכזיים: קו לנטה נוי שבצפון וקו לנטה יאי שבדרום - הגדול, המיושב והתיירותי מביניהם. האי מציע שילוב מושלם של חופים מדהימים, טבע פראי, חיי כפר מסורתיים ושלווה יוצאת דופן.',
  sections: [
    {
      title: 'חופים מומלצים',
      type: 'sub-headers',
      description:
        'קו לנטה מתהדר ברצועת חוף ארוכה ומרהיבה בצדו המערבי, עם חופים לבנים, מי טורקיז ושקיעות בלתי נשכחות. בין החופים הבולטים:',
      content: [
        {
          subtitle: 'Khlong Dao Beach',
          text: 'החוף המרכזי, מציע מגוון רחב של שירותי תיירות, מסעדות וריזורטים.',
        },
        {
          subtitle: "Phra Ae Beach (לונג ביץ')",
          text: 'חוף ארוך ופופולרי עם אווירה רגועה ומסעדות חוף.',
        },
        {
          subtitle: 'Klong Khong Beach',
          text: 'חוף המתאים למחפשים שקט, עם אווירה רגועה ופחות תיירים.',
        },
        {
          subtitle: 'Ba Kantiang Bay',
          text: 'חוף מבודד עם נוף מרשים המתאים לרומנטיקנים.',
        },
        {
          subtitle: 'Nui Bay',
          text: 'חוף קטן ופראי, גן עדן לחובבי טבע ושקט.',
        },
      ],
    },
    {
      title: 'שמורות טבע וטיולים בטבע',
      type: 'sub-headers',
      description:
        'קו לנטה מציעה מגוון של שמורות טבע ואפשרויות לטיולים וחיבור עם הטבע המקומי:',
      content: [
        {
          subtitle: 'הפארק הלאומי קו לנטה (Mu Ko Lanta National Park)',
          text: 'ממוקם בקצה הדרומי של האי, כולל חופים לבנים, מצוקי גיר גבוהים, מגדלור עם תצפית פנורמית ושבילי הליכה מרהיבים דרך יערות גשם.',
        },
        {
          subtitle: 'מערת הטיגריס (Tham Khao Mai Kaew Cave)',
          text: 'מערה מרשימה עם נטיפים וזקיפים, מסלול הליכה אתגרי בתוך המערה.',
        },
        {
          subtitle: 'שמורת המנגרובים Tung Yee Peng',
          text: 'ניתן לשוט בקיאק בין יערות המנגרובים ולפגוש קופי מקוק.',
        },
      ],
    },
    {
      title: 'פעילויות מים וסיורי איים',
      type: 'sub-headers',
      description:
        'קו לנטה הינו יעד מעולה לצלילה ושנורקלינג, עם מים צלולים ושוניות אלמוגים מרהיבות:',
      content: [
        {
          subtitle: 'צלילה ושנורקלינג',
          text: 'האי קרוב לאתרי צלילה מהטובים בתאילנד, כמו קו רוק וקו האא.',
        },
        {
          subtitle: 'סיור 4 האיים (Four Islands Tour)',
          text: 'שייט הכולל ביקור באיים מבודדים, עצירות לשנורקלינג ומערת האמרלד הקסומה (Emerald Cave) עם לגונה נסתרת.',
        },
        {
          subtitle: 'קיאקים בים ובמנגרובים',
          text: 'חוויה ייחודית של שיט בין יערות המנגרובים או לאורך החופים.',
        },
      ],
    },
    {
      title: 'כפרים ותרבות מקומית',
      type: 'sub-headers',
      description:
        'האי מציע הזדמנות מצוינת להכיר את התרבות המקומית והאותנטית של האזור:',
      content: [
        {
          subtitle: 'העיר העתיקה של קו לנטה (Koh Lanta Old Town)',
          text: 'עיירה קסומה עם בתי עץ מסורתיים בני יותר מ-100 שנה, מסעדות אותנטיות ושוק מקומי קטן.',
        },
        {
          subtitle: 'כפר הצוענים הימיים (Sea Gypsy Village)',
          text: 'חוויית מפגש עם בני שבט האוראק לאווי, החיים על פי מסורתם הייחודית, עם סירות עץ מסורתיות ובתים על כלונסאות.',
        },
      ],
    },
    {
      title: 'חיי לילה ובילויים',
      type: 'sub-headers',
      description:
        'קו לנטה אינו יעד למסיבות המוניות, אך מציע חיי לילה רגועים באווירה נעימה:',
      content: [
        {
          subtitle: 'ברים על החוף',
          text: "כמו Why Not Bar ו-Feelin' Good Beach Club עם מוזיקה חיה ושקיעות מטריפות.",
        },
        {
          subtitle: 'שוק לילה מקומי',
          text: 'בעיקר בצפון האי ליד Khlong Dao Beach, עם אוכל רחוב תאילנדי מעולה.',
        },
      ],
    },
    {
      title: 'אוכל ומסעדות מומלצות',
      type: 'sub-headers',
      description: 'קו לנטה מציע מבחר רחב של מסעדות מקומיות ובינלאומיות:',
      content: [
        {
          subtitle: 'Yang Garden',
          text: 'מסעדה מעולה עם מנות גורמה.',
        },
        {
          subtitle: 'Same Same But Different',
          text: 'מסעדה פופולרית על החוף עם נוף מרהיב.',
        },
        {
          subtitle: 'Drunken Sailors',
          text: 'קפה וביסטרו עם וייב רגוע ואוכל נהדר.',
        },
        {
          subtitle: "May's Kitchen",
          text: 'מומלצת למחפשים אוכל תאילנדי אותנטי.',
        },
      ],
    },
    {
      title: 'תחבורה והתניידות באי',
      type: 'sub-headers',
      description: 'ישנן מספר אפשרויות להתנייד באי וכן דרכים שונות להגיע אליו:',
      content: [
        {
          subtitle: 'קטנועים ואופנועים',
          text: 'הדרך הפופולרית ביותר לטייל באי, מאפשרת חופש תנועה וגישה למקומות מרוחקים.',
        },
        {
          subtitle: 'טוק-טוקים מקומיים',
          text: 'אלטרנטיבה טובה למי שלא רוצה או לא יכול לנהוג. זמינים בכל רחבי האי.',
        },
        {
          subtitle: 'אופניים',
          text: 'השכרת אופניים אפשרית באזורים השטוחים יותר של האי, אידיאלית לטיולים קצרים.',
        },
        {
          subtitle: 'הגעה לאי',
          text: 'תחבורה ימית ויבשתית - ניתן להגיע לקו לנטה כל השנה דרך היבשה באמצעות מעבורת או גשר ובעונת התיירות אף בסירות מהירות מקראבי, פוקט וקו פי פי.',
        },
      ],
    },
    {
      title: 'למי מתאים הביקור בקו לנטה?',
      type: 'text',
      content:
        'קו לנטה הינו יעד מושלם למחפשים חופים יפים, שקט ורוגע, טבע פראי וטיולים. האי מתאים במיוחד לזוגות, משפחות, חובבי טבע וצלילה ולאלו המעדיפים חוויה תאילנדית אותנטית יותר, רחוקה מהמולת התיירות ההמונית.',
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, קו לנטה הינו יעד חלומי למחפשים את תאילנד האותנטית - חופים שקטים, אוכל מקומי מעולה, טבע מרהיב ותרבות מרתקת.',
    },
  ],
};
